<template>
  <v-container>
    <v-row dense align="center" justify="space-between">
      <v-col cols="auto">
        <v-btn icon @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-col>

      <v-col class="text-center">
        <div class="text-h4 font-weight-bold">
          <v-icon large color="red">mdi-map-marker-radius</v-icon>
          Evento y Venta Agroturísmo
        </div>
      </v-col>
      <v-col cols="12" class="pb-3">
        <div class="text-h7">
          Presiona el botón para crear un nuevo evento y venta Agroturística
        </div>
      </v-col>
      <v-col v-if="user_can.add" cols="12">
        <v-btn router to="/ru/agroturismo" depressed class="primary">
          <span style="font-size: 25px">🚶‍♀️🐎</span>
          <v-icon left>mdi-plus</v-icon>
          Agrega uno Nuevo
        </v-btn>
      </v-col>
      <v-col cols="12" class="tt">
        <div class="text-h6">
          <v-icon large color="red">mdi-camera</v-icon> Ver mis eventos
          Agroturísticos
        </div>
        <div class="text-h8">
          Presiona el evento Agroturístico para agregar o modificar información de esa fecha
        </div>
      </v-col>
      <!-- Fila de espaciado -->
      <v-col cols="12" class="py-5"></v-col>
      <!-- Puedes ajustar py-5 a py-3 o py-2 según el espacio que prefieras -->
      <!-- Mensaje si no hay fincas  -->
      <v-col v-if="Object.keys(agroturismos).length === 0" cols="12">
        <div class="text-body-1 text-center font-italic">
          Aún no tienes ningun evento Agroturístico
        </div>
      </v-col>
      <!-- listado de actividades agroturísticas en el almacenamiento local -->
      <v-col cols="12" class="lista">
        <v-list three-line>
          <template v-for="agroturismo in agroturismos">
            <form-card
              :key="agroturismo.id"
              :top-text="`Finca: ${getNombreDeFinca(agroturismo.id_finca)}`"
              :middle-text="agroturismo.descripcion"
              :bottom-text="`Actividad: ${getNombreDeParcela(agroturismo.id_parcela)}`"
              :top-right-text="`Personas: ${agroturismo.produccion} - Fecha: ${agroturismo.fecha}`"
              :middle-right-text="`Personas: ${agroturismo.produccion}`"
              :bottom-right-text="producerDescription(agroturismo.productor)"
              :sincronized="agroturismo.sincronizado"
              @click="traerRegistroYNavegar(agroturismo)"
            />
          </template>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { producerDescription } from '@/utilidades'

export default {
  name: 'Agroturismos',
  computed: {
    ...mapState('registros', ['agroturismos']),
    ...mapGetters('registros', ['getNombreDeFinca', 'getNombreDeParcela']),
    user_can() {
      return this.$store.getters['auth/userCan'](this.$route.path)
    },
  },
  mounted() {
    this.$store.commit('ui/updateToolbar', 'Agroturismos')
  },
  methods: {
    producerDescription,
    async traerRegistroYNavegar(registro) {
      if (registro.sincronizado === true) {
        await this.$store.dispatch('registros/getAgroturismo', {
          id: registro.id,
        })
      }
      this.$router.push(`/ru/agroturismo/${registro.id}`)
    },
  },
}
</script>
<style>
.tt {
  margin-top: 40px;
  margin-bottom: -20px;
}
.lista {
  margin-top: 20px;
}
</style>
